import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-darkBg to-darkBg border-t border-secondary/10">
      <div className="section-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="inline-block mb-4 hover-lift">
              <img src="/Cosmik Logo/Kolonia_Logo.png" alt="Cosmik Drones" className="h-10 w-auto" />
            </Link>
            <p className="text-lightText/70 text-sm mb-4">
              Premier drone cinematography and aerial imaging services in the Lehigh Valley and beyond.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/josh.kolonia"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lightText/70 hover:text-secondary transition-colors hover-lift"
                aria-label="Facebook"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"
                  />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/josh.kolonia/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lightText/70 hover:text-primary transition-colors hover-lift"
                aria-label="Instagram"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                  />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/channel/cosmikdrones"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lightText/70 hover:text-primary transition-colors hover-lift"
                aria-label="YouTube"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/cosmik-drones"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lightText/70 hover:text-blue-500 transition-colors hover-lift"
                aria-label="LinkedIn"
              >
                <FaLinkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-primary text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-secondary text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Aerial Photography
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Cinematic Videography
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  FPV Drone Filming
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Real Estate & Property
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-lightText/70 hover:text-secondary transition-colors hover-lift inline-block">
                  Events & Sports Coverage
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-primary text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
                            <li className="flex items-start group">                <svg                  className="h-5 w-5 text-secondary mr-2 mt-0.5 group-hover:animate-pulse-slow"                  fill="none"                  viewBox="0 0 24 24"                  stroke="currentColor"                >                  <path                    strokeLinecap="round"                    strokeLinejoin="round"                    strokeWidth={2}                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"                  />                </svg>                <span className="text-lightText/70 group-hover:text-lightText transition-colors">                  (610) 509-0867                </span>              </li>
                            <li className="flex items-start group">                <svg                  className="h-5 w-5 text-secondary mr-2 mt-0.5 group-hover:animate-pulse-slow"                  fill="none"                  viewBox="0 0 24 24"                  stroke="currentColor"                >                  <path                    strokeLinecap="round"                    strokeLinejoin="round"                    strokeWidth={2}                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"                  />                </svg>                <span className="text-lightText/70 group-hover:text-lightText transition-colors">                  Josh@Cosmikdrones.com                </span>              </li>
              <li className="flex items-start group">
                <svg
                  className="h-5 w-5 text-secondary mr-2 mt-0.5 group-hover:animate-pulse-slow"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-lightText/70 group-hover:text-lightText transition-colors">
                  Bethlehem, Pennsylvania
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-darkCard text-center">
          <p className="text-lightText/50 text-sm">
            &copy; {currentYear} Cosmik Drones. All rights reserved.
          </p>
          <div className="mt-2 flex justify-center space-x-6 text-sm">
            <a href="#" className="text-lightText/50 hover:text-secondary transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-lightText/50 hover:text-secondary transition-colors">
              Terms of Service
            </a>
          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-6 text-sm text-gray-400">
          <Link to="/privacy-policy" className="text-gray-400 hover:text-primary transition-colors">Privacy Policy</Link>
          <span className="mx-2">|</span>
          <Link to="/terms-of-service" className="text-gray-400 hover:text-primary transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 